import type { SagaIterator } from 'redux-saga';
import { select, call, put } from 'redux-saga/effects';
import type { Client } from '@peloton/api/utils';
import { getSignedInUserId } from '@peloton/auth/redux';
import { track } from '@engage/analytics/actions';
import { trackUpdatedClassLanguageSettings } from '../analytics';
import { updateClassLanguagePreferences as update } from '../api';
import type { SettingsModel } from '../models';
import type { UpdateClassLanguagePreferencesAction } from '../redux';
import { setSettings } from '../redux';

export default function* (
  client: Client,
  { settings, previousSettings, presenter, source }: UpdateClassLanguagePreferencesAction,
): SagaIterator {
  const userId = yield select(getSignedInUserId);

  if (userId) {
    try {
      const res: { data: SettingsModel } = yield call(update, client, userId, settings);
      yield put(setSettings(res.data));

      yield put(
        track(
          trackUpdatedClassLanguageSettings(
            source,
            previousSettings.classLanguagePreferences,
            settings.classLanguagePreferences,
            settings.preferredClassLanguage ?? undefined,
          ),
        ),
      );
      yield call(presenter.displaySuccessMessage);
    } catch {
      yield call(presenter.displayErrorMessage);
    }
  } else {
    yield call(presenter.redirectToLoginPage);
  }
}
